import CustomInput from "components/CustomInput";
import { useAddClientAccountMutation, useGetAllClientAccountsQuery, useGetClientAccountByIdQuery } from "../clientAccountSlice";
import { useGetClientsQuery } from "../clientSlice";
import CreateIcon from '@material-ui/icons/Create';
import { useSelector } from "react-redux";
import { selectIsAdmin } from "features/user/userSlice";
import LoadingSpinner from "components/LoadingSpinner";
import { useState } from "react";
import AddIcon from '@material-ui/icons/Add';
import NotificationProvider from "components/NotificationProvider";
import EditClientPopupStyle from "./EditClientPopupStyle";
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import ClientAccountRow from "./ClientAccountRow/ClientAccountRow";
import { clientAccountLabels } from "./EditClientPopupConsts";

const { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, Card, Grid } = require("@material-ui/core");

const useStyles = EditClientPopupStyle;

const EditClientPopup = ({ open, setOpenEditPopup, clientToEdit, setClientToEdit }) => {
    const classes = useStyles();

    const isAdmin = useSelector(selectIsAdmin);
    const canEditSuperDispatchCustomerId = isAuthorized(permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_SUPER_DISPATCH_CUSTOMER_ID);

    let { data: clientAccounts, error: clientAccountsError, isLoading: isLoadingClientAccounts } = useGetAllClientAccountsQuery(clientToEdit?.id, { skip: !clientToEdit?.id });
    let { data: defaultClientAccount, isLoading: isLoadingDefaultClientAccount } = useGetClientAccountByIdQuery(clientToEdit?.accountId, { skip: !clientToEdit?.accountId || !canEditSuperDispatchCustomerId });
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null, { skip: !isAdmin });

    clientAccounts = clientAccounts || [];
    clients = clients || [];
    let client = clients?.find(c => c.id === clientToEdit?.id);

    const [openDialog, setOpenDialog] = useState(false);

    const [addSubClient] = useAddClientAccountMutation()

    const onAddSubClient = async (name) => {
        let result = await addSubClient({ name: name, clientId: clientToEdit?.id });
        if (result.error) {
            NotificationProvider.error("Error adding the sub client");
        } else {
            NotificationProvider.success("Successfully added the sub client");
            setOpenDialog(false);
        }
        return true;
    }

    return (
        <Dialog open={open} maxWidth='md' fullWidth >
            <DialogTitle>{`Edit Client ${client?.name}`}</DialogTitle>
            <DialogContent>
                {isLoadingClientAccounts || isLoadingDefaultClientAccount ?
                    <LoadingSpinner loading={isLoadingClientAccounts || isLoadingDefaultClientAccount} /> :
                    <Grid item>
                        {defaultClientAccount?.isDefault &&
                            <div className={classes.defaultAccount}>
                                <div className={classes.title}>{clientAccountLabels.CLIENT_ACCOUNT}</div>
                                <ClientAccountRow account={defaultClientAccount} canEditName={false} />
                            </div>}
                        <Grid container direction='row' justifyContent='space-between'>
                            <div className={classes.title}>Sub Clients</div>
                            <AddSubClient
                                onAddSub={onAddSubClient}
                                openDialog={openDialog}
                                setOpenDialog={setOpenDialog}
                            />
                        </Grid>
                        {!!clientAccounts.length ?
                            <List >
                                {clientAccounts.map(subClient =>
                                    <ClientAccountRow key={subClient.id} account={subClient} />
                                )}
                            </List>
                            : <>
                                <div className={classes.noItemsDiv}>
                                    <h3>There are no sub clients to display</h3>
                                </div>
                            </>}
                    </Grid>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => setOpenEditPopup(false)}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditClientPopup;

export function AddSubClient({ onAddSub, openDialog, setOpenDialog }) {

    const [subToAdd, setSubToAdd] = useState();
    const [loading, setLoading] = useState();

    return (
        <>
            <div>
                <Button
                    color='primary'
                    variant='outlined'
                    onClick={() => setOpenDialog(true)}
                    startIcon={<AddIcon />}
                >
                    Add Sub Client
                </Button>
            </div>
            <Dialog open={openDialog}>
                <DialogTitle>Add Sub Client</DialogTitle>
                <DialogContent>
                    <CustomInput
                        label='Name'
                        elementType='input'
                        value={subToAdd}
                        onChange={(val) => setSubToAdd(val)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => { setSubToAdd(); setOpenDialog(false); }}
                    >
                        Cancel
                    </Button>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={async () => {
                            setLoading(true);
                            await onAddSub(subToAdd);
                            setLoading(false);
                            setSubToAdd();
                        }}
                        disabled={!subToAdd || loading}
                    >
                        {loading ? 'Saving' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}